import React from 'react'
import PropTypes from 'prop-types'
import {
  StyledCarouselWrapper,
  StyledHideOverflow,
  StyledSlidesWrapper,
} from './styles'
import { CarouselButtons } from '../carouselButtons'

const CarouselWrapper = (props) => {
  const {
    index,
    length,
    maxItemsVisible,
    gap,
    onNext,
    onPrevious,
    hideHoverBorder,
    children,
  } = props

  return (
    <StyledCarouselWrapper>
      <CarouselButtons
        showButtons={length > maxItemsVisible && !!onNext && !!onPrevious}
        onNext={onNext}
        onPrevious={onPrevious}
      >
        <StyledHideOverflow>
          <StyledSlidesWrapper
            length={length}
            index={index}
            maxItemsVisible={maxItemsVisible}
            gap={gap}
            hideHoverBorder={hideHoverBorder}
          >
            {children}
          </StyledSlidesWrapper>
        </StyledHideOverflow>
      </CarouselButtons>
    </StyledCarouselWrapper>
  )
}

CarouselWrapper.defaultProps = {
  index: null,
  length: null,
  maxItemsVisible: 4,
  gap: 0.75,
  onNext: null,
  onPrevious: null,
  hideHoverBorder: false,
  children: <></>,
}

CarouselWrapper.propTypes = {
  index: PropTypes.number.isRequired,
  length: PropTypes.number.isRequired,
  maxItemsVisible: PropTypes.number,
  gap: PropTypes.number,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  hideHoverBorder: PropTypes.bool,
  children: PropTypes.any,
}

export { CarouselWrapper }
